import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/uNDxthn6orTLeMqg86sypA/atardecer_dibujo_(1).png';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-[#faf4ec]" data-id="element-93" data-mp="9ll6ipqopkjt">
      <div className="absolute inset-0" data-id="element-94" data-mp="4mi297ij3icw">
        <img src={HERO_IMG} alt="Ilustración de un atardecer sobre una ciudad venezolana para la guía 5 Días Para Encontrar Tu Equilibrio" className="h-full w-full object-cover" data-id="element-95" data-mp="4njpeactjvaz" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2a1f18]/70 via-[#2a1f18]/45 to-[#3a2e28]/80" data-id="element-96" data-mp="x8jmznet0shq" />
      </div>

      <div className="relative mx-auto flex min-h-[92vh] max-w-3xl flex-col items-center justify-center px-6 py-24 text-center" data-id="element-97" data-mp="ncgiwc0e6js5">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="mb-6 text-sm uppercase tracking-[0.35em] text-[#f3e9dd]/80" data-id="element-98" data-mp="3d2ldtocrhr6i">
          Tu Mundo Equilibrado
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1
      }} className="font-serif text-4xl font-medium leading-tight text-[#faf4ec] sm:text-5xl md:text-6xl" data-id="element-99" data-mp="3o7vllomspvze">
          5 Días Para Encontrar Tu Equilibrio
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.3
      }} className="mt-6 max-w-xl font-serif text-lg italic leading-relaxed text-[#f3e9dd]/95 sm:text-xl" data-id="element-100" data-mp="30gq6jbooj7q5">
          El 24 de junio sentimos que el suelo se movió bajo nuestros pies…
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.4
      }} className="mt-4 max-w-xl text-base leading-relaxed text-[#f3e9dd]/90 sm:text-lg" data-id="element-101" data-mp="2hk83vz8alnf4">
          Una guía gratuita para ti, a quien el miedo, el dolor y la
          incertidumbre de los terremotos todavía te invaden.
        </motion.p>

        <motion.a href="#descargar" initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.45
      }} className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#b06a4a] px-8 py-4 text-sm font-semibold uppercase tracking-wider text-[#faf4ec] shadow-lg shadow-black/20 transition-colors hover:bg-[#8f5238]" data-id="element-102" data-mp="id9r45wihxq4">
          Descargar gratis
        </motion.a>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1,
        y: [0, 8, 0]
      }} transition={{
        opacity: {
          duration: 1,
          delay: 1
        },
        y: {
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }
      }} className="absolute bottom-8 text-[#f3e9dd]/70" aria-hidden="true" data-id="element-103" data-mp="x1efnqi8x3gt">
          <ArrowDownIcon className="h-5 w-5" data-id="element-104" data-mp="1xavzsqiykkaf" />
        </motion.div>
      </div>
    </header>;
}